<div class="ds-account">
  <div class="ds-account__content">
    <ds-tabs class="ds-account__tabs"
             [class.full-width]="accountTab === 'security'"
             [activeTabId]="accountTab"
             [ngClass]="{'ds-account__tabs-with-offer': (currentSubscription && currentSubscription.type === UserSubscriptionType.FREE && websiteCopied) || (currentSubscription && [UserSubscriptionType.ONE_PRODUCT, UserSubscriptionType.PREMIUM].includes(currentSubscription.type) && aiStarterAnnual && aiStarterAnnual.plan.trialPeriodNumber)}"
             (onActiveTabChange)="accountsTabChange($event)">
      <ds-tab-head tabId="account-settings" [activeTabId]="accountTab">
        <span class="ds-account__sidebar-link">{{'text_personalInformation' | dbText}}</span>
      </ds-tab-head>
      <ds-tab-head tabId="security" [activeTabId]="accountTab">
        <span class="ds-account__sidebar-link">{{'text_accountSecurity' | dbText}}</span>
      </ds-tab-head>
      <ds-tab-content [tabId]="accountTab" [activeTabId]="accountTab"
      >
        <div class="ds-panel_flex ds-panel-account-settings">
          <div id="db-panel__body" class="db-panel__body">
            <div *ngIf="accountTab === 'account-settings'">
              <db-account-settings [isMobile]="isMobile"></db-account-settings>
            </div>
            <div *ngIf="accountTab === 'security'">
              <db-security-settings></db-security-settings>
            </div>
          </div>
        </div>
      </ds-tab-content>
    </ds-tabs>
  </div>
</div>
